export default function FAQSection() {
  const faqs = [
    {
      q: '尾巴漫画网上的韩国漫画都是免费的吗？',
      a: '是的，尾巴漫画网上的所有韩国漫画均提供在线免费阅读服务。我们致力于为广大韩漫爱好者提供免费、优质的阅读体验，无需付费即可畅享海量韩漫资源。',
    },
    {
      q: '网站上的漫画画质如何？有删减吗？',
      a: '我们提供的所有韩国漫画均为高清画质，且保证无删减内容。尾巴漫画网坚持原汁原味的内容呈现，让您享受最完整的韩漫阅读体验。',
    },
    {
      q: '漫画多久更新一次？',
      a: '尾巴漫画网每日更新热门韩漫，月均更新超过3000个章节。热门连载漫画通常保持与韩国同步的更新频率，确保您及时追更。',
    },
    {
      q: '如何找到我想看的漫画？',
      a: '您可以通过首页的分类导航、搜索功能或排行榜来找到喜欢的韩国漫画。网站提供恋爱、奇幻、动作、悬疑等多种分类，方便您快速浏览。',
    },
    {
      q: '支持手机阅读吗？',
      a: '当然支持！尾巴漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。下拉式阅读设计在手机上体验尤为流畅舒适。',
    },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="faq-heading">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 id="faq-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于尾巴漫画网，您可能想了解的信息</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h4 className="text-sm font-medium text-foreground-800 pr-8">{faq.q}</h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-100 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-sm text-foreground-500 group-open:text-primary-500 group-open:rotate-180 transition-all duration-300"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}